export default __webpack_public_path__ + "static/media/MenuDots.7bc3a225.svg";